document.addEventListener('DOMContentLoaded', function () {
  // cursor spotlight glow on product cards and promo banner
  document.querySelectorAll('.product-card, .promo').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      card.style.background = 'radial-gradient(circle at ' + x + '% ' + y + '%, rgba(255,255,255,0.14), rgba(255,255,255,0.06) 60%)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.background = '';
    });
  });

  // cart quantity stepper (+/-)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-btn');
    if (!btn) return;
    var stepper = btn.closest('.qty-stepper');
    var input = stepper.querySelector('.cart-qty');
    var val = parseInt(input.value || '0', 10);
    if (btn.classList.contains('qty-plus')) {
      val = val + 1;
    } else if (btn.classList.contains('qty-minus')) {
      val = Math.max(0, val - 1);
    }
    input.value = val;
  });
});
